import { Context } from './types';

export const hasPassword = (context: Context) => {
  console.log(context);
  return !!context.password;
};
